import { useEffect, useState } from "react";
import { PRICING, WETRAVEL_EMBED } from "@/lib/thailand";
import { track } from "@/lib/analytics";
import { onUiChange, getUiState, setUiFlag } from "@/lib/uiState";
import { wetravelState, wetravelFallback } from "@/lib/wetravel";

// Restrained mobile-only sticky reservation CTA for /Thailand2027.
// IMPORTANT: the button element must stay MOUNTED from first render — the official
// WeTravel loader binds click handlers once at init via querySelectorAll, so a
// conditionally-unmounted button would never be wired (owner-reported dead-button bug).
// Visibility is therefore controlled with CSS only (transform/opacity/pointer-events).
export default function StickyReserve() {
  const [show, setShow] = useState(false);
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const onScroll = () => setShow(mq.matches && window.scrollY > 700);
    const onChange = () => onScroll();
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    mq.addEventListener("change", onChange);
    const unsub = onUiChange((s) => setBlocked(s.menu || s.overlay));
    setBlocked(getUiState().menu || getUiState().overlay);
    return () => { window.removeEventListener("scroll", onScroll); mq.removeEventListener("change", onChange); unsub(); };
  }, []);

  const visible = show && !blocked;

  // Publish visibility so BackToTop and the Passport popup can position/yield.
  useEffect(() => { setUiFlag("stickyCta", visible); return () => setUiFlag("stickyCta", false); }, [visible]);

  return (
    <div data-testid="sticky-reserve" aria-hidden={!visible}
      className={`fixed bottom-0 inset-x-0 z-[60] border-t border-gold/30 bg-noir/95 backdrop-blur-md px-4 pt-3 transition-[transform,opacity] duration-300 md:hidden ${visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"}`}
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}>
      <button type="button" data-testid="reserve-sticky" tabIndex={visible ? 0 : -1}
        className="wtrvl-checkout_button w-full flex items-center justify-center border border-gold bg-gold text-black px-6 py-3.5 font-body text-[11px] uppercase tracking-[0.16em]"
        data-env={WETRAVEL_EMBED.env} data-version={WETRAVEL_EMBED.version} data-uid={WETRAVEL_EMBED.uid}
        data-uuid={WETRAVEL_EMBED.uuid} href={WETRAVEL_EMBED.checkoutUrl}
        onClickCapture={() => { track("reserve_your_spot_click", { source_page: "Thailand2027", cta_location: "sticky_mobile" }); if (wetravelState() === "failed") wetravelFallback(); }}>
        Reserve Your Spot · $299 Deposit
      </button>
    </div>
  );
}
